import React, {useContext} from 'react';
import firebase, {auth} from "../../firebase/firebase";
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import moment from "moment";
import AddAdminValidation from "../../validation/add-admin";
import {useFormik} from "formik";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import {Alert} from "@mui/material";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import {AuthUserContext} from "../../providers/AuthProvider";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Portal from "@mui/material/Portal";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import Autocomplete from '@mui/material/Autocomplete';
import SearchIcon from '@mui/icons-material/Search';
import PostActivity from "../../helpers/post-activity";

export default function ManageAdmin(){
  const navigator = useNavigate()
  const {profile} = useContext(AuthUserContext);
  const [open, setOpen] = React.useState(false);
  const [isLoading, setLoading] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const [admins, setAdmins] = React.useState([]);
  const [searchAdmin , setSearchAdmin] = React.useState('')
  const [filterData, setFilterData] = React.useState([])
  const [isAddForm, setAddForm] = React.useState(false)
  const formik = useFormik({
    initialValues:  AddAdminValidation.initialValues,
    validationSchema: AddAdminValidation.AddAdminSchema,
    onSubmit: async (values) => {
      setLoading(true)
      try {
        const isEmailExists = await auth.fetchSignInMethodsForEmail(values.email)
        if(isEmailExists && isEmailExists.length === 0) {
          const response = await axios.post(
            'https://api-taost.herokuapp.com/api/v1/secure/add-admin',
            // 'http://localhost:8080/api/v1/secure/add-admin',
            {...values, type: 'admin', super: values.userType === 'super-admin'},
            {headers: {'Content-Type': 'application/json', 'Id-Token': profile?.idToken}}
          )
          PostActivity({
            text: `"${profile.name}" ${profile?.super === true ? 'super admin' : 'admin'}
                         has sent an invite to "${values?.name}" ${values.userType === 'super-admin' ? 'super admin' : 'admin'}`,
            uid: profile.uid,
            createdBy:profile?.uid
          }).then()
          setAddForm(!isAddForm)
          loadData()
          handleClickOpen()
          setLoading(false)
        } else {
          setLoading(false)
          formik.setFieldError('email', 'Your email address is already exists.')

        }

        // alert(JSON.stringify(response))
      } catch (e) {
        setLoading(false)
        console.log(e)
      }
    },
  });

 const showAddForm = () => {
   formik.handleReset(formik);
   setAddForm(!isAddForm)

 }
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: 'none',
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: '#F1F4F8',
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));
  const loadData = () => {
    const statsRef = firebase
      .firestore()
      .collection('users')
      .orderBy('createdAt', 'desc')
      .limit(10)
      .where('userType', '==', 'admin' )
      .get()
      .then((snaps) => {
        if (snaps.size > 0) {
          const data = [];
          snaps.docs.forEach((d) => {
            data.push({id:d.id ,...d.data()});
          })
          setAdmins(data);
        }
      })
  }
  const search = () => {
     
    if (searchAdmin === '') {
      setFilterData([...admins])
    } else {
      const regex = new RegExp(searchAdmin);
      setFilterData(admins.filter((u) => regex?.test(u.title) || regex?.test(u.creatorName) ));
    }
  }
  React.useEffect(() => {
    loadData()
  }, [])

  const filteredAdmin = searchAdmin === "" ? admins : admins.filter((item) => {return (item.name.toLowerCase()).startsWith(searchAdmin.toLowerCase())})
  return (
    <Container maxWidth={'full-width'}  sx={{height: 'calc(100vh - 120px)', p: 5, textAlign: 'left',overflowY: 'scroll'}}>
      <Stack direction={'column'} spacing={5}>
        <Stack direction={'row'} spacing={3}>
          <Typography variant={'h4'} color={'primary'}>
            Manage Admin
          </Typography>
          {
            !isAddForm ?
            <Button variant={'contained'} color={'primary'} onClick={() => showAddForm()}>
              Add new admin
            </Button> : <><Typography variant={'h4'} color={'primary'}>
                >
              </Typography><Typography variant={'h4'} color={'primary'}>
                Add Admin
              </Typography></>
          }
          <div style={{flex: 1}}/>
          <Stack direction='row'  justifyContent="center"
                   alignItems="center">
              <TextField value={searchAdmin}
               onChange={(e) => setSearchAdmin(e.target.value)}
               onKeyDown={(e) => {
                  if (e.code === "Enter") {
                    search()
                  }
                }}
                 sx={{width:'90%', textAlign:'left', outline:'none'}} size={"small"}/>
              <Button variant={'contained'} sx={{ borderRadius: 0, boxShadow:'none', py: 1.15}} size={"small"} onClick={search}><SearchIcon/></Button>
            </Stack>
          {/* <Autocomplete spacing={2} sx={{ width: 300 }}
              freeSolo
              id="free-solo-2-demo"
              disableClearable
              options={ ["all" , ...admins.map((option) => option.name)]}
              value = {searchAdmin}
              onChange={(e , newValue) => { setSearchAdmin(newValue)}}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label=  {<SearchIcon />}
                  InputProps={{
                    ...params.InputProps,
                    type: 'search',
                  }}/>
                  )}
          /> */}
        </Stack>

        {
          !isAddForm ?
          <TableContainer >
          <Table sx={{ minWidth: 700 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <StyledTableCell sx={{fontWeight: 'bolder', fontSize:16, }}>Name</StyledTableCell>
                <StyledTableCell align="left" sx={{fontWeight: 'bolder', fontSize:16, }}>Email</StyledTableCell>
                <StyledTableCell align="left" sx={{fontWeight: 'bolder', fontSize:16, }}>Joining date</StyledTableCell>
                <StyledTableCell align="left" sx={{fontWeight: 'bolder', fontSize:16, }}>Details</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {admins.length > 0
                && filteredAdmin.map((row) => (
                <StyledTableRow
                  key={row.name}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <StyledTableCell component="th" scope="row">
                    {row.name}
                  </StyledTableCell>
                  <StyledTableCell align="left">{row.email}</StyledTableCell>
                  <StyledTableCell align="left">{moment(row.createdAt.seconds * 1000).format('DD/MM/YYYY')}</StyledTableCell>
                  <StyledTableCell align="left"><Button variant={'text'} sx={{textDecoration: 'underline'}} onClick={() => navigator('/admin/manage-admin-details', {state: {admin: row}})}>View</Button></StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
          </TableContainer>
            :
            <Stack component={'form'} onSubmit={formik.handleSubmit} direction="column"
                   justifyContent="flex-start"
                   alignItems="center"
                   spacing={3}>

              <TextField value={formik.values.name}
                         onChange={formik.handleChange}
                         error={formik.touched.name && Boolean(formik.errors.name)}
                         helperText={formik.touched.name && formik.errors.name}
                         label={'Name'} name="name" variant="outlined" sx={{width:'100%'}} />

              <TextField value={formik.values.email}
                         onChange={formik.handleChange}
                         error={formik.touched.email && Boolean(formik.errors.email)}
                         helperText={formik.touched.email && formik.errors.email}
                         label={'Email'} name="email" variant="outlined" sx={{width:'100%'}} />

              <TextField value={formik.values.contact}
                         onChange={formik.handleChange}
                         error={formik.touched.contact && Boolean(formik.errors.contact)}
                         helperText={formik.touched.contact && formik.errors.contact}
                         label={'Contact'} name="contact" variant="outlined" sx={{width:'100%'}} />

              <TextField value={formik.values.userType}
                         onChange={formik.handleChange}
                         error={formik.touched.userType && Boolean(formik.errors.userType)}
                         helperText={formik.touched.userType && formik.errors.userType}
                         label={'User Type'} name="userType" variant="outlined" sx={{width:'100%'}} select >

                <MenuItem value={'admin'}>
                  Admin
                </MenuItem>
                <MenuItem value={'super-admin'}>
                  Super Admin
                </MenuItem>
              </TextField>
              <TextField value={formik.values.password}
                         onChange={formik.handleChange}
                         error={formik.touched.password && Boolean(formik.errors.password)}
                         helperText={formik.touched.password && formik.errors.password}
                         label={'Create password'} name="password" variant="outlined" sx={{width:'100%'}} type={'password'} autoComplete={false}/>


             <Stack direction={'row'} spacing={5}>
               <Button onClick={() => setAddForm(!isAddForm)} >Go back</Button>
               <Button variant={'contained'} sx={{px: 3}} type={'submit'} endIcon={isLoading ? <CircularProgress size={20}/> : '' } disabled={isLoading}>
                 Invite
               </Button>
             </Stack>

            </Stack>
        }

      </Stack>

      <Portal>
        <div>

          <Dialog
            open={open}
            onClose={handleClose}
            fullWidth={true}
            maxWidth={'sm'}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title" color={'primary'}>
              Thank you!
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Your invitation was successfully sent.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={()=> {
                handleClose();

              }} variant={'contained'} size={'small'} sx={{px: 3}}>
               OK
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </Portal>
    </Container>
  )
}